<div class="address-form">
  <p class="address-form--heading">{{ titleKey | translate }}</p>
  <p class="address-form--info">{{ 'POI.EditPoiOnMapInfoNew' | translate }}</p>
  @if (formGroup) {
    <dv-dynamic-form
      class="dynamic-form"
      [elements]="elements | translateElements"
      [formGroup]="formGroup">
    </dv-dynamic-form>
  }
  <div class="address-form__actions">
    <dv-button (click)="onConfirmClicked(undefined)">
      {{ 'General.Cancel' | translate }}
    </dv-button>
    <dv-button
      color="secondary"
      (click)="onConfirmClicked(formGroup.getRawValue())"
      [disabled]="!formGroup.dirty">
      {{ 'General.Save' | translate }}
    </dv-button>
  </div>
</div>
